var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_vm._v(_vm._s(_vm.entrega.persona_nombre)+" "+_vm._s(_vm.entrega.persona_apellido)),_c('br'),_vm._v("Cantidad: "+_vm._s(_vm.entrega.cantidad)+" unidades"),_c('br'),_vm._v("Descripción: "+_vm._s(_vm.entrega.entrega_descripcion)+" "),_c('br'),_vm._v(" Producto: "+_vm._s(_vm.entrega.producto_nombre))])
}
var staticRenderFns = []

export { render, staticRenderFns }